export default __webpack_public_path__ + "664a9f5.png";